/**
 * After a deploy, tabs opened earlier still reference the old hashed page files, which no longer exist.
 * Loading one fails with a "dynamically imported module" error; a reload picks up the new build.
 */
const KEY = "mf:stale-reload-at";
const STALE = /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

export function isStaleBuildError(err: unknown): boolean {
  const message = err instanceof Error ? err.message : typeof err === "string" ? err : "";
  return STALE.test(message);
}

/** Reloads the page unless we already did in the last 30 seconds (so a real outage can't loop). Returns true if reloading. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Storage blocked: still reload once; the browser keeps us from looping on the same navigation.
  }
  window.location.reload();
  return true;
}
